function CircleIcon(props) {
  return (
    <div className="flex rounded-full justify-center bg-lightblue w-40 h-40">
      <img className="place-self-center" src={props.icon} alt="" />
    </div>
  );
}

export default CircleIcon;